import { fork, put, take, takeEvery } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { getFreebets } from 'app/lib/account/actions';

import {
  PROCESS_STAKES,
  PROCESS_STAKES_COMPLETE, ProcessStakesComplete,
  SUBMIT_STAKE_SUCCESS, SubmitStakeSuccess,
} from '../actions/submission';

// ---

function* refreshFreeBetsProcessor(): SagaIterator {
  yield takeEvery(PROCESS_STAKES, function* () {
    yield fork(refresh);
  });
}

// ---

type RefreshActions = SubmitStakeSuccess | ProcessStakesComplete;

function* refresh() {
  while (true) {
    const action: RefreshActions = yield take([SUBMIT_STAKE_SUCCESS, PROCESS_STAKES_COMPLETE]);

    if (action.type === PROCESS_STAKES_COMPLETE) {
      break;
    }

    if (typeof action.payload.requestPayload?.freeBetId === 'number') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      yield put(getFreebets());
      break;
    }
  }
}

export default refreshFreeBetsProcessor;
